export default {
  solicitarDocumento: state => state.redeSIM.solicitarDocumento
};
